import React from "react";
import "../../styles/spinner.css";

const Spinner = () => {
  return <div className="spinner"></div>;
};

export default Spinner;
